import {bytesToSize} from './helper';

export const createPreviewMarkup = (file, event, options, error) => {
  const nameArray = file.name.split('.');
  const expansion = nameArray[nameArray.length - 1];

  const hasErrorClass = error ? ' is-invalid' : '';

  return  `<div class="input-upload__preview-item${hasErrorClass}" >

            ${hasErrorClass ? '<div class="input-upload__preview-text"> Попробуйте еще раз </div>' : '<div class="input-upload__preview-text"> Заменить резюме </div>'}
            ${options.fileInfo ? `<div class="input-upload__preview-file-info" />
              ${options.fileInfo.fileName ? `<span class="input-upload__preview-file-name"" />
                ${file.name}
              </span>` : ''}
              ${options.fileInfo.fileSize ? `<span class="input-upload__preview-file-size"" />
                ${bytesToSize(file.size)}
              </span>` : ''}
              <button class="input-upload__preview-item-remove"  type="button">
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.5 5L5.5 15" stroke="#B3B3B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M5.5 5L15.5 15" stroke="#B3B3B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>` : ''}
          </div>`;
};
